import { AxiosError } from 'axios';
import { QueryConfig, useQuery } from 'react-query';
import { __DEV__ } from '~src/config';
import { loadTenderUsers } from '~src/services/api/tender';
import { DbTenderUser } from '~src/types/db';
import { useProjectId } from '../useProjectId';

export const useTenderUsers = (
  queryConfig: QueryConfig<DbTenderUser[], AxiosError> & {
    enabled?: boolean;
  } = {}
) => {
  const projectId = useProjectId();
  const { enabled, ...options } = queryConfig;

  // if enabled = undefined then enabled = true
  const enabledOverwrite = enabled || enabled === undefined;

  const tenderUsersQuery = useQuery<DbTenderUser[], AxiosError>(
    [
      'tenderUsersList',
      {
        projectId: String(projectId),
      },
    ],
    loadTenderUsers,
    {
      staleTime: 60 * 1000, // 1min
      enabled: enabledOverwrite && projectId,
      refetchOnWindowFocus: !__DEV__,
      ...options,
    }
  );

  return tenderUsersQuery;
};
